// "More from The Joy of Pancakes" cards on the press page. Edit copy here;
// layout in PressKit.jsx's OtherOfferings section consumes the array.
// Adding/removing cards = one edit in one place.
//
// `accent` picks which of the JoP pan-flag colors the card foregrounds for
// border/glow treatment so the five cards don't all look identical.

export const OFFERINGS = [
  {
    id: "commissions",
    title: "Custom Commissions",
    accent: "pink",
    body: "Preserved, framed pancake art for gifts, weddings, retirements, anniversaries, and \"I can't believe you actually pancaked my dog\" moments. Anything you can describe gets rendered in batter, preserved and framed, signed by the artist, and shipped ready to hang.",
  },
  {
    id: "branded-content",
    title: "Branded Content",
    accent: "gold",
    body: "Custom pancake art and video production for brands seeking the warmth and weirdness that pancake art uniquely provides. Viral short-form, campaign tentpoles, or one-off executive keepsakes — all delivered in restaurant-quality batter.",
  },
  {
    id: "preservation-kits",
    title: "Pancake Art Preservation Kits",
    accent: "sky",
    price: "$20",
    body: "Make a pancake. Keep it forever. Each kit contains an instruction card, two sheets of wax paper, decoupage glue with applicator, and a collector's frame sized to fit any pancake from Dan's griddle (which has a grid built in for exactly this reason). Designed for families, fans of the act, and beginning pancake artists.",
  },
  {
    id: "wellamade-kandi",
    title: "Wellamade Pancake Kandi",
    accent: "pink",
    price: "Bracelets $8–10 · Earrings ~$20",
    body: "Pancake- and breakfast-themed kandi bracelets and earrings, handmade by Wella using novelty beads from Jelli Bead and a Steven-Universe-meets-roadside-diner aesthetic. Available in the gift shop at events. Custom on-site beading is also available as an event add-on: Wella sets up alongside the live pancake art and makes one-of-a-kind jewelry for guests in real time. Client pricing available for pre-purchase or activation.",
  },
  {
    id: "take-home-merch",
    title: "Take-Home Merch for Event Guests",
    accent: "gold",
    body: "Every Golden Ticket keepsake page includes a built-in option to order custom merch featuring the guest's own pancake design — shirts, totes, sticker packs. Your activation keeps generating delight (and impressions) long after the napkins are gone.",
  },
];
